<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <md-button class="md-raised md-success mr-4" @click="newContact()">New Contact</md-button>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Contacts</h4>
            <p class="category">Blocked contacts</p>
          </md-card-header>
          <md-card-content v-if="blockedContacts.length">
            <md-table v-model="blockedContacts" table-header-color="green">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Contact Email" >
                  <p class="reservation_table-name">
                    {{item.email}}
                  </p>
                </md-table-cell>
                <md-table-cell md-label="Created Date">{{ getDate(item.updated_at) }}</md-table-cell>
                <md-table-cell md-label="Status">Blocked</md-table-cell>
                <md-table-cell md-label="">
                  <span class="cursor_pointer" @click="openDelete(item.id)">
                    <md-icon class="color_red">delete</md-icon>
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-table>
            <md-table-cell v-if="!blockedContacts.length"><p class="px-3">No blocked contacts yet. </p></md-table-cell>
          </md-table>
        </md-card>
      </div>
    </div>
    <!-- dialog-->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog md-size-100">
      <md-dialog-title>Create contact</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field maxlength="6" class="mb-1">
          <label>Contact Email</label>
          <md-input
              v-model="modalData.email"
              type="email"
              maxlength="254"
              required
              placeholder="Email"
              :class="{ 'is-invalid': isSubmitted && $v && $v.modalData && $v.modalData.email.$error }"
          ></md-input>
          <p v-if="isSubmitted && $v && $v.modalData && $v.modalData.email.$error" class="error_msg">
            <span v-if="!$v.modalData.email.required">Email is required.</span>
            <span v-else-if="!$v.modalData.email.email">Please enter a valid email address.</span>
          </p>
        </md-field>
<!--        <span class="text-danger" v-if="modalErrors.short_description">-->
<!--          {{modalErrors.short_description[0]}}-->
<!--        </span>-->
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="onCancel()">Close</md-button>
        <md-button
            class="md-success"
            :disabled="$v && $v.modalData && $v.modalData.$invalid"
            @click="onConfirm()"
        >Create</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- dialog-->

<!--    del  -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Contact</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this contact?</h4>
        <br>
        <p>This action cannot be undone and the contact details will be permanently removed.</p>
      </div>
      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
<!--    del  -->
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {email, required} from "vuelidate/lib/validators";
export default {
  name: "AdminBlockedContacts",
  data() {
    return {
      isSubmitted: false,
      showDialog: false,
      showDelDialog: false,
      delContactId: null,
      modalData: {
        email: ''
      },
      blockedContacts: []
    }
  },
  validations: {
    modalData: {
      email: {
        required,
        email
      },
    }
  },
  created() {
    this.getAllContacts()
  },
  methods: {
    ...mapActions(['createBlockContact', 'getBlockedContacts', 'removeBlockedContact']),
    getDate(input) {
      const date = new Date(input);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    getAllContacts() {
      this.getBlockedContacts()
      .then(res => {
        this.blockedContacts = res.data.data
      })
    },
    openDelete(id) {
      this.delContactId = id
      this.showDelDialog = true
    },
    onConfirmDelete() {
      this.removeBlockedContact(this.delContactId)
          .then(res => {
            if(res.status == 200) {
              this.showDelDialog = !this.showDelDialog
              this.delContactId = null
              this.getAllContacts()
            }
            if(res.status == 404) {
              this.delError = res.response.data.error
            }
          })
    },
    newContact() {
      this.showDialog = true
    },
    onConfirm() {
      this.isSubmitted = true;
      if (this.$v && this.$v.modalData) {
        this.$v.modalData.$touch();
        // stop if invalid
        if (this.$v.modalData.$invalid) {
          return;
        }
      }

      this.createBlockContact(this.modalData.email)
      .then(res => {
        this.getAllContacts()
        this.showDialog = false
        this.modalData.email = '';
        this.isSubmitted = false;
        if (this.$v && this.$v.modalData) this.$v.modalData.$reset();
      })
    },
    onCancel() {
      this.showDialog = false;
      this.isSubmitted = false;
      this.modalData.email = '';
      if (this.$v && this.$v.modalData) this.$v.modalData.$reset();
    }
  }
}
</script>

<style scoped lang="scss">
.color_red {
  color: red !important;
}
</style>
